import angular from "angular";

angular
    .module('app')
    .component('userDeleteForm', {
        template: require('./user-delete-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.user = $ctrl.resolve.user;
    }

    $ctrl.confirm = function () {
        $ctrl.loading = true;

        $http
            .post(`/admin/users/${$ctrl.user.id}`, {_method: 'DELETE'})
            .then(response => {
                Notifier.success('Успешно удален', 2);

                $ctrl.close();
            })
            .catch(error => {
                Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
            })
            .finally(() => {
                $ctrl.loading = false;
            })
    };

}
